import { Table, Card, Button, Pagination, Row, Col, Form, Stack } from "react-bootstrap";
import {
    RiArrowUpDownLine,
    RiDeleteBin6Line,
    RiDownloadLine,
    RiEditLine,
    RiLayoutGridLine,
    RiMapPinLine,
    RiMore2Fill,
    RiSearchLine,
    RiTruckLine,
} from "react-icons/ri";
import React, { useEffect, useMemo, useState } from "react";
import { getMyVehicles } from "../../services/Networkcall";
import { errorAlert } from "../common/Alert";
import { Loader } from "../common/Loader";
import EditVehicle from "./EditVehicle";
import { vehicleLengthOptions } from "../../constants/Constants";
import VehicleFilters from "./VehicleFilters";
import { ReactSelect } from "../common/ReactSelect";

const VehicleTable = ({vehicleData, loading, setLoading, fetchMyVehicles}) => {
    const [showModal, setShowModal] = useState(false);
    const [selectedVehicle, setselectedVehicle] = useState(null);
    const [search, setSearch] = useState("");
    const [filters, setFilters] = useState({ search: "", status: "All", vehicleType: "", });
    const [debouncedSearch, setDebouncedSearch] = useState("");
    const [analyticsData, setAnalyticsData] = useState({ total: 0, active: 0, inactive: 0 });

     
    //  ===============HNDLE ADD VEHICLE MODAL================
    const handleOpenModal = (id) => {
        setselectedVehicle(id);
        setShowModal(true);
    }

    const handleCloseModal = () => {
        setShowModal(false);
    }

    // ===========GET VEHICLE TYPE=========================
    const getVehicleType = (length) => {

        const vehicle = vehicleLengthOptions?.find(
            (data) => data?.value === length
        );

        return { type: vehicle?.name?.v_type || "", length: vehicle?.name?.v_length || "" }
    };


    useEffect(() => {
        setLoading(true);
        const timer = setTimeout(() => {
            setDebouncedSearch(filters.search);
            setLoading(false);
        }, 500);

        return () => clearTimeout(timer);
    }, [filters.search]);


    const handleFilterChange = (name, value) => {
        setFilters((prev) => ({
            ...prev,
            [name]: value,
        }));
    };


    // 🔍 CLIENT-SIDE SEARCH + FILTER (on current page data from server)
    const filteredData = useMemo(() => {
        const searchText = debouncedSearch?.toLowerCase() || "";
        return (
            vehicleData?.filter((item) => {
                const matchesSearch =
                    !searchText ||
                    item?.vehicleName
                        ?.toLowerCase()
                        ?.includes(searchText) ||
                    item?.licensePlate
                        ?.toLowerCase()
                        ?.includes(searchText);

                const matchesStatus =
                    filters.status === "All" ||
                    item?.status === filters.status;

                const matchesVehicleType =
                    !filters.vehicleType ||
                    item?.length === filters.vehicleType;
 

                return matchesSearch && matchesStatus && matchesVehicleType;
            }) || []
        );
    }, [
        vehicleData,
        debouncedSearch,
        filters.status,
        filters.vehicleType,
    ]);


    const options = [{
        value: "",
        label: "All Types",
    }, ...vehicleLengthOptions.map((e) => ({
        value: e.value,
        label: (
            <Stack direction="horizontal" className="justify-content-between w-100 text-start" gap={5}  >
                <span className="fw-bold f-sm-8 ">{e.name.v_type}</span>
                <span className="text-start text-sm-end text-nowrap f-sm-8 w-25">{e.name.v_length}</span>
            </Stack>
        ),
        isDisabled: e.isDisabled || false,
    }))];


    return (<>
        <Loader show={loading} />
        {/* FILTERS */}
        <Row className="mv-filters mt-3">

            {/* SEARCH */}
            <Col xl={4} lg={6} md={12}>
                    <label className="label">Search</label>
                <div className="mv-search">

                    <RiSearchLine />
                    <input
                        placeholder="Search vehicle / plate"
                        value={filters.search}
                        onChange={(e) =>
                            setFilters((prev) => ({
                                ...prev,
                                search: e.target.value,
                            }))
                        }
                    />
                </div>
            </Col>

            <Col xl={3} lg={3} md={4}>
                <div className="mv-field">
                    <label>Status</label>
                    <Form.Select
                        value={filters.status}
                        onChange={(e) =>
                            handleFilterChange("status", e.target.value)
                        }
                    >
                        <option value="All">All Status</option>
                        <option value="ACTIVE">ACTIVE</option>
                        <option value="INACTIVE">INACTIVE</option>
                    </Form.Select>
                </div>
            </Col>

            <Col xl={5} lg={5} md={5}>
                <div className="mv-field">
                    <label>Type</label>
                    <ReactSelect
                        value={
                            options.find(
                                (option) =>
                                    option.value === filters.vehicleType
                            ) || null
                        }
                        options={options}
                        name="vehicleType"
                        onChange={(selected) =>
                            handleFilterChange(
                                "vehicleType",
                                selected?.value || ""
                            )
                        }
                    />
                </div>
            </Col>

        </Row>

        <Card className="mv-table">
            {/* HEADER */}
            <div className="mv-table-header">
                <h6>Vehicles ({filteredData?.length || 0})</h6>

                {/* <div className="mv-actions">
                    <Button variant="light" className="mv-btn-icon">
                        <RiLayoutGridLine className="me-2" />
                        Columns
                    </Button>

                    <Button variant="light" className="mv-btn-icon">
                        <RiDownloadLine className="me-2" />
                        Export
                    </Button>
                </div> */}
            </div>

            {/* TABLE */}
            <div className="table-responsive">
                <Table hover>
                    <thead>
                        <tr>
                            <th> <div className="th-sort"> Vehicle <RiArrowUpDownLine /> </div> </th>
                            <th> <div className="th-sort">  Plate / VIN <RiArrowUpDownLine /> </div> </th>
                            <th> <div className="th-sort"> Type <RiArrowUpDownLine /> </div> </th>
                            {/* <th> <div className="th-sort">  Year <RiArrowUpDownLine />  </div>  </th> */}
                            {/* <th>  <div className="th-sort">  Location <RiArrowUpDownLine />  </div>  </th> */}
                            <th> <div className="th-sort">  Status <RiArrowUpDownLine />  </div> </th>
                            {/* <th> <div className="th-sort">   Last Entry <RiArrowUpDownLine /> </div>  </th> */}
                            {/* <th>Driver</th> */}
                            <th>Actions</th>
                        </tr>
                    </thead>

                    <tbody>
                        {filteredData?.map((item, i) => (
                            <tr key={i}>
                                <td>
                                    <div className="vehicle-cell">
                                        {/* <img  src="https://via.placeholder.com/50" alt="" className="vehicle-img" /> */}
                                        <div>
                                            <strong>{item?.vehicleName}</strong>
                                            {/* <p className="sub">Truck</p> */}
                                        </div>
                                    </div>
                                </td>

                                <td>
                                    <strong>{item?.licensePlate}</strong> <br /> <p>{item.key}</p>
                                </td>
                                <td>
                                    <div className="type-cell">  <RiTruckLine />  {getVehicleType(item?.length)?.type}  </div>
                                    <small className="ms-4">  {getVehicleType(item?.length)?.length} </small>
                                </td>
                                {/* <td>{item.year}</td> */}

                                {/* <td>
                                    <div className="location-cell">  <RiMapPinLine />
                                    </div>
                                </td> */}

                                <td>
                                    <span className={`badge ${item.status.toLowerCase()}`}>  {item.status}  </span>
                                </td>

                                {/* <td>
                                    {item.date}  <br />   <small>{item.miles}</small>
                                </td> */}

                                {/* <td>{item.driver}</td> */}

                                <td>
                                    <div className="mv-actions-cell">
                                        <Button variant="outline-primary" className="icon-btn text-primary p-2 edit" onClick={() => { handleOpenModal(item) }}>
                                            <RiEditLine className="mb-4"/>
                                        </Button>

                                        {/* <Button className="icon-btn p-2 delete">
                                            <RiDeleteBin6Line />
                                        </Button> */}
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </div>
        </Card>
        {showModal && <EditVehicle show={showModal} closeModal={handleCloseModal} vehicle={selectedVehicle} fetchVehicleList={fetchMyVehicles} />}
    </>);
};

export default React.memo(VehicleTable);
